import { IItem, ITotals } from '@checkout/items';
import * as cx from 'classnames';
import * as React from 'react';
import { InjectedIntlProps, injectIntl } from 'react-intl';
import { SummaryRow } from '..';
import { contextCheckoutConfig } from '../../../config/contextCheckoutConfig';
import { ProductsList } from '../../container';
import { Countdown } from '../../presentational';
import messages from './../../../i18n/base-en';
import * as Styles from './Summary.scss';

interface IOwnProps {
  totals: ITotals;
  title?: string;
  items?: IItem[];
  withThumbnails?: boolean;
}

type Props = IOwnProps & InjectedIntlProps;

const Summary: React.SFC<Props> = ({ intl, totals, title, items, withThumbnails }) => {
  const { formatMessage } = intl;
  const { countDownTo } = contextCheckoutConfig.ui.freeShippingCountDown;
  const { itemsTotalPriceAsNumber, itemsTotalPrice } = totals;
  const enableCalculations = countDownTo && itemsTotalPriceAsNumber && countDownTo > itemsTotalPriceAsNumber;
  const countdownValue = enableCalculations ?  countDownTo - itemsTotalPriceAsNumber : 0;
  const countdownPercent = enableCalculations ? (itemsTotalPriceAsNumber / countDownTo) * 100  : 100;
  const countdownMessage  = countdownPercent < 100 ? formatMessage(messages.countdown_label) : formatMessage(messages.countdown_100_percent_label);
  const currency = countdownPercent < 100 ?  itemsTotalPrice.replace(/[0-9]/g, '') : '';

  const titleClassNames = cx({
    [Styles.title]: true,
    [Styles.receiptTitle]: !!items
  });

  if (!totals) { return null; }

  return (
    <div className={Styles.content}>
      {title && <div className={titleClassNames}>{title}</div>}
      {items && <div className={Styles.items}><ProductsList items={items} readOnly={true} withThumbnails={withThumbnails} /></div>}
      <SummaryRow label={formatMessage(messages.subtotal_label)} value={totals.itemsTotalPrice} />
      <SummaryRow
        label={formatMessage(messages.shipping_sumary_label)}
        value={totals.shippingPrice}
      />
      {totals.handlingCostPriceAsNumber > 0 && (
        <SummaryRow
          label={formatMessage(messages.payment_handling_label)}
          value={totals.handlingCostPrice}
        />
      )}
      {contextCheckoutConfig.ui.freeShippingCountDown.enabled && (
        <Countdown
          label={countdownMessage}
          value={countdownValue}
          fill={countdownPercent}
          currency={currency}
        />
      )}
      {totals.taxDeducted && (
        <SummaryRow
          label={formatMessage(messages.tax_deducted_label)}
          value={totals.taxDeducted}
        />
      )}
      <SummaryRow total={true} label={formatMessage(messages.total_label)} value={totals.grandTotalPrice} />
      {totals.taxPercent > 0 && (
        <SummaryRow
          variant={'smaller'}
          label={formatMessage(messages.including_tax_label, { taxPercent: totals.taxPercent })}
          value={totals.grandTotalPriceTax}
        />
      )}
      {totals.totalDiscountPrice && (
        <SummaryRow variant={'small'} label={formatMessage(messages.discount_label)} value={totals.totalDiscountPrice} />
      )}
    </div>
  );
};

export default injectIntl<IOwnProps>(Summary);
